import AppCoursecategoriesIndex from "./courseCategory.vue";
import AppCoursecategoriesList from "./list/list.vue";
import AppCoursecategoriesItem from "./item/item.vue";

const routes = [
  {
    path: "courseCategory",
    component: AppCoursecategoriesIndex,
    meta: {
      auth: {
        roles: "courseCategory.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "courseCategory.index",
        component: AppCoursecategoriesList,
        meta: {
          auth: {
            roles: "courseCategory.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "courseCategory.create",
        component: AppCoursecategoriesItem,
        meta: {
          auth: {
            roles: "courseCategory.create",
            redirect: { name: "courseCategory.index" }
          }
        }
      },
      {
        path: ":id",
        name: "courseCategory.edit",
        component: AppCoursecategoriesItem,
        meta: {
          auth: {
            roles: "courseCategory.update",
            redirect: { name: "courseCategory.index" }
          }
        }
      }
    ]
  }
];

export default routes;
